// Въпросът „Излизане без запис?" на работните листове — един и същ вид за
// доставка, изписване, прехвърляне, инвентаризация и разнасяне: кой документ
// напускате, какво се губи (незаписаните редове) и два конкретни бутона —
// „Остани" (фокусът, Enter) и „Излез без запис". Нов документ с чернова не
// пита изобщо — черновата се записва и листът излиза тихо
// (`components/drafts/useWorksheetLeave`); въпросът остава за редакцията и
// разнасянето.
import { useCallback } from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useConfirm } from "./useConfirm";
import type { ConfirmPreviewItem } from "./confirmTypes";

export type UnsavedSummary = {
  // „новото изписване" / „редакцията на доставка №12" (след „Излизане от")
  document: string;
  // нов документ — всички редове са незаписани; при редакция редовете са
  // „в листа" (не знаем кои точно са променени)
  isNew?: boolean;
  // собствено обяснение (разнасянето губи замените, не редове)
  explanation?: string;
  items?: ConfirmPreviewItem[];
  // общият брой редове, когато `items` е орязан
  total?: number;
};

export const useLeaveConfirm = () => {
  const { t } = useTranslation();
  const confirm = useConfirm();
  return useCallback(
    (summary: UnsavedSummary) =>
      confirm({
        intent: "danger",
        icon: <LogoutOutlined />,
        title: t("inventoryPage.cfmLeaveTitle", { document: summary.document }),
        explanation: summary.explanation ?? t("inventoryPage.cfmLeaveText"),
        preview: summary.items?.length
          ? {
              caption: t(summary.isNew ? "inventoryPage.cfmLeaveCaption" : "inventoryPage.cfmLeaveSheetCaption"),
              items: summary.items,
              total: summary.total,
            }
          : undefined,
        note: { kind: "final", text: t("inventoryPage.cfmLeaveFinal") },
        confirmLabel: t("inventoryPage.cfmLeaveConfirm"),
        cancelLabel: t("inventoryPage.cfmLeaveStay"),
      }),
    [confirm, t],
  );
};

export default useLeaveConfirm;
